import React, { useState, useEffect } from "react";
import { handleOnClickLogout, getAllBackgrounds } from "../constants";
import { NavBar, SideBar, Breadcrumb, Backgrounds } from "../components";

const VirtualBackground = () => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const [loading, setLoading] = useState(false);
  const [backgrounds, setBackgrounds] = useState([]);

  useEffect(() => {
    getAllBackgrounds(token, setBackgrounds);
  }, []);

  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-hidden justify-start items-center text-secondary">
      <NavBar
        handleLogout={handleOnClickLogout}
        setLoading={setLoading}
        token={token}
      />
      <div className="flex flex-row w-full h-full">
        <SideBar active={"virtual backgrounds"} />
        <div className="flex flex-col w-full bg-red-100">
          <Breadcrumb breads={["Virtual Backgrounds"]} />
          <Backgrounds backgrounds={backgrounds} />
        </div>
      </div>
    </div>
  );
};

export default VirtualBackground;
